import React, { Component } from 'react';

import Input from '../../../input';
import Regulations from '../../regulations';
import decl from '../../helpers/declension';
import { setCookie, monthTimeout } from '../../../../helpers/cookie';

export default class PushkinPay extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    namePattern = /^[А-Яа-яЁё \-]+$/;

    sanitizeName = value =>
        (value || '').replace(/[^А-Яа-яЁё \-]/g, '').replace(/\s{2,}/g, ' ').replace(/-{2,}/g, '-');

    handleNameChange = (field, value) => {
        const sanitizedValue = this.sanitizeName(value);
        this.props.onEditCheckout(field, sanitizedValue);
    };

    buildFio = () => {
        const { checkout: { lastName, firstName, middleName } } = this.props;

        return [lastName, firstName, middleName]
            .map(part => (part || '').trim())
            .filter(Boolean)
            .join(' ');
    };

    // Проверка по Пушке
    checkInputs() {
        const {
            checkout: { lastName, firstName, middleName },
        } = this.props;

        const isRequiredValid = value =>
            Boolean(value && value.trim() && this.namePattern.test(value.trim()));
        const isOptionalValid = value =>
            !value || (value.trim() && this.namePattern.test(value.trim()));

        return isRequiredValid(lastName) && isRequiredValid(firstName) && isOptionalValid(middleName);
    }

    buyPushkinCard = () => {
        const fio = this.buildFio();
        const data = {
            'order-id': this.props.orderId,
            'pay-method': 'pushkin_card',
            'fio': fio,
        };

        const headers = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
        };

        if (process.env.NODE_ENV !== 'dev') headers.credentials = 'include';

        this.setState({
            loading: true,
        });

        const route = '/local/php_interface/api/v2/payment/pay/';

        // try to buy a ticket
        fetch(route, headers)
            .then(response => response.json())
            .then(json => {
                if (json.status === 'success') {
                    if (json.data.bonus_order) {
                        this.setState({
                            loading: false,
                        });
                    } else {
                        if (json.data.redirect_url !== '') {
                            // renderBankIframe(json.data.redirect_url);
                            window.location.href = json.data.redirect_url;
                            setCookie('UNPAID_ORDER', 'TRUE');
                            setCookie('PAYMENT_LINK', json.data.redirect_url);
                            setCookie('PAYMENT_METHOD', 'pushkin_card');
                            setCookie('PUSHKIN_FIO', fio, monthTimeout);
                            setCookie('userChooseInfo', 0, monthTimeout);
                        }

                        // close popup
                        window.closePopupInterval = setTimeout(() => {
                            if ($('#bank_iframe').length > 0) {
                                window.postMessage('ticketTimeout', '*');
                            }
                        }, window.expire_date - Date.now());

                        this.setState({
                            loading: false,
                        });
                    }
                } else if (json.data.available || json.errors) {
                    const err = json.errors;
                    returnError([err]);
                }
            })
            .catch(() => {
                this.setState({
                    loading: false,
                });
            });
    };

    render() {
        const { selected, amount, checkout, user } = this.props;
        const { lastName = '', firstName = '', middleName = '' } = checkout;

        const { loading } = this.state;

        const btnClasses = ['btn', 'btn--accent'];

        if (!this.checkInputs()) btnClasses.push('btn--disable');
        if (loading) btnClasses.push('btn--loading');

        const choosedTicketClasses = ['hint__tickets'];
        if (selected.length) choosedTicketClasses.push('hint__tickets--active');

        const choosedTicketText = selected.length
            ? `${selected.length} ${decl(selected.length, [
                'билет',
                'билета',
                'билетов',
            ])} за ${amount} руб.`
            : `Выберите места`;


        return (
            <div className="buy-checkout-side__container">
                {/* mobile version */}
                <div className="scheme-popup__top">
                    <button
                        className="scheme-popup__top-btn left"
                        type="button"
                        onClick={() => this.props.onBackClick()}
                    >
                        <svg
                            className="icon--shev"
                            width="10"
                            height="15"
                            viewBox="0 0 5 8"
                        >
                            <path d="M3.6 7.8c.2.1.4.2.6.2.4 0 .8-.4.8-.9 0-.2-.1-.4-.3-.6l-2.6-2.5 2.6-2.5c.2-.2.3-.4.3-.6 0-.5-.4-.9-.8-.9-.2 0-.4.1-.6.2l-3.3 3.1c-.3.3-.4.9 0 1.2l3.3 3.3z" />
                        </svg>
                    </button>
                    <h4 className="heading heading--2">Оформление заказа</h4>
                </div>

                {/* desktop version */}
                <button
                    onClick={() => this.props.onBackClick()}
                    className="buy-checkout-side__back"
                >
                    <svg width="8" height="5">
                        <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down"></use>
                    </svg>
                    Назад
                </button>

                <h4 className="buy-checkout-side__title">
                    Фамилия, имя, отчество, как в паспорте
                </h4>
                <div className="buy-checkout-side__inp-container">
                    <Input
                        label="Фамилия"
                        name="lastName"
                        error={false}
                        placeholder="Как в паспорте"
                        value={lastName}
                        onChange={val => this.handleNameChange('lastName', val)}
                        required
                    />
                    <Input
                        label="Имя"
                        name="firstName"
                        error={false}
                        placeholder="Как в паспорте"
                        value={firstName}
                        onChange={val => this.handleNameChange('firstName', val)}
                        required
                    />
                    <Input
                        label="Отчество (при наличии)"
                        name="middleName"
                        error={false}
                        placeholder="Укажите, если есть"
                        value={middleName}
                        onChange={val => this.handleNameChange('middleName', val)}
                    />
                </div>

                <Regulations link={user.pd} />

                <div className="checkout-result__wrapper">
                    <button
                        className={choosedTicketClasses.join(' ')}
                        onClick={() => this.props.showTooltip()}
                    >
                        {choosedTicketText}
                    </button>
                    <button
                        className={btnClasses.join(' ')}
                        type="button"
                        onClick={() => {
                            this.buyPushkinCard();
                        }}
                    >
                        <span>Купить билеты</span>
                    </button>
                </div>
            </div>
        );
    }
}